import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply persisted theme before paint to avoid flash.
try {
  const t = localStorage.getItem("bagfluence-theme") || "dark";
  document.documentElement.classList.add(t);
} catch {
  document.documentElement.classList.add("dark");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
